module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/auth/cookie.component.html
// module id = 154
// module chunks = 6